import React from "react";
import LocalizationContext from "../utils/LocalizationContext";
import SpecialObject from "../pages/SpecialObject";
import NavBar from "../components/NavBar";
import useMenu from "../utils/Hooks/useMenu";
import ValidateURL from "../utils/ValidateURL";

export default () => {
  const menu = useMenu();
  const currentPage = {
    menuGroup: menu?.Configuration,
    key: "SpecialObject",
  };

  return (
    <ValidateURL currentPage={currentPage}>
      <LocalizationContext.Provider value={null}>
        <NavBar
          MenuOptions={menu}
          currentPage={currentPage}
        >
          <SpecialObject />
        </NavBar>
      </LocalizationContext.Provider>
    </ValidateURL>
  );
};
